
const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">O que nossos clientes dizem</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-xl shadow-md">
            <div className="flex items-center mb-4">
              <div className="text-hero-blue">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-xl">★</span>
                ))}
              </div>
            </div>
            <p className="text-gray-600 mb-6 italic">
              "Implementamos o sistema solar há 18 meses e já recuperamos mais de 70% do investimento. A plataforma de gestão nos permite acompanhar a economia em tempo real."
            </p>
            <div className="flex items-center">
              <div>
                <p className="font-semibold text-gray-800">Ricardo Silva</p>
                <p className="text-sm text-gray-500">Diretor Financeiro, TechCorp Brasil</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-md">
            <div className="flex items-center mb-4">
              <div className="text-hero-blue">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-xl">★</span>
                ))}
              </div>
            </div>
            <p className="text-gray-600 mb-6 italic">
              "Nossa fábrica conseguiu reduzir os custos com energia em 92%. O suporte técnico é excelente e o sistema funciona mesmo em dias nublados."
            </p>
            <div className="flex items-center">
              <div>
                <p className="font-semibold text-gray-800">Ana Carvalho</p>
                <p className="text-sm text-gray-500">CEO, Indústrias Verdes S.A.</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-md">
            <div className="flex items-center mb-4">
              <div className="text-hero-blue">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-xl">★</span>
                ))}
              </div>
            </div>
            <p className="text-gray-600 mb-6 italic">
              "Além da economia significativa, nossos clientes valorizam nosso compromisso com sustentabilidade. O certificado de energia verde tem sido um diferencial competitivo importante."
            </p>
            <div className="flex items-center">
              <div>
                <p className="font-semibold text-gray-800">Marcos Oliveira</p>
                <p className="text-sm text-gray-500">Proprietário, Rede de Supermercados Eco</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
